import { Grid } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import PageHeader from "../../components/UI/Headers/PageHeader/PageHeader";
import CustomTabs from "../../components/UI/Tabs/CustomTabs/CustomTabs";
import { TabItemEntity } from "../../entities/UIEntities/TabItem";
import { ROLES_HIERARCHY, TABLES } from "../../enums/Enums";
import { userActions } from "../../redux/reducers/UserReducer";
import store from "../../redux/Store";
import Icons from "../../resources/icons/Icons";
import Strings from "../../resources/Strings";
import classes from "../Parkers/ParkersPage.module.css";
import useHistoryService from "../../hooks/useHistoryService";

const HistoryPage = () => {
  const gmtUser = useSelector((state) => state.user.gmtUser);
  const [tableName, setTableName] = useState(Strings.TABS_NAMES.HISTORY);
  let tabs = [];

  const [selectionModel, setSelectionModel] = useState(null);
  const { getHistoryTable } = useHistoryService();

  const onRowClick = (selectionModel) => {
    const isNotEmptyModel = Object.keys(selectionModel).length !== 0;
    setSelectionModel(selectionModel);
    if (isNotEmptyModel) {
      store.dispatch(userActions.setShowUserInfoWindow(true));
    }
  };

  let historyTab = new TabItemEntity(
    Strings.TABS_NAMES.HISTORY,
    TABLES.HISTORY,
    getHistoryTable(onRowClick)
  );

  tabs = [historyTab];

  const handleTabChanged = (tableName) => {
    setTableName(tableName);
  };

  return (
    <div className={classes.parkersPage}>
      <Grid container spacing={4} className={classes.parkersContainer}>
        <Grid xs={12} item className={classes.item}>
          <PageHeader
            icon={Icons.HISTORY2}
            pageTitle={Strings.TITLES.HISTORY_PAGE}
            validRole={
              gmtUser?.role?.hierarchy <= ROLES_HIERARCHY.ADMINISTRATOR
            }
          />
          {tabs && (
            <CustomTabs
              initialTab={Strings.TABS_NAMES.HISTORY}
              tabs={tabs}
              onTabChange={handleTabChanged}
              isHidden={true}
            ></CustomTabs>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default HistoryPage;
